import { Injectable, signal } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { IUser } from '../../interfaces/user.interface';

/** Een aanvraag vanaf het inlogscherm (auth: /AccessRequest). */
export interface AccountRequest {
  id: number;
  /** "club": registreert zijn club; "member": wil een account bij zijn club. */
  kind: 'club' | 'member' | string;
  clubName: string;
  city?: string;
  country?: string;
  team?: string;
  /** Wat de aanvrager koos op het formulier, geen platformrol. */
  role?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  message?: string;
  language?: string;
  source?: string;
  status: 'pending' | 'approved' | 'rejected' | string;
  createdAtUtc: string;
  resolvedAtUtc?: string;
  resolvedUserSid?: string;
  rejectReason?: string;
}

export interface AccountRequestApprove {
  club: string;
  role: string;
  teams: string[];
}

export interface AccountRequestApproveResult {
  request: AccountRequest;
  user: IUser;
  invitationSent: boolean;
}

@Injectable({ providedIn: 'root' })
export class AccountRequestsService {
  private readonly authUrl = `${environment.authUrl}/AccessRequest`;

  /** Openstaande aanvragen, voor de teller in het menu. */
  readonly pendingCount = signal(0);

  constructor(private http: HttpClient) {}

  public list(status: string, limit = 100, page = 0): Observable<{ items: AccountRequest[]; total: number }> {
    const params = new HttpParams().set('status', status).set('limit', String(limit)).set('page', String(page));
    return this.http.get<{ items?: AccountRequest[]; total?: number }>(this.authUrl, { params })
      .pipe(map(res => ({ items: res?.items ?? [], total: res?.total ?? 0 })));
  }

  public refreshCount(): void {
    const params = new HttpParams().set('status', 'pending');
    this.http.get<{ count: number }>(`${this.authUrl}/Count`, { params }).subscribe({
      next: res => this.pendingCount.set(res?.count ?? 0),
      error: () => undefined,
    });
  }

  public approve(id: number, body: AccountRequestApprove): Observable<AccountRequestApproveResult> {
    return this.http.post<AccountRequestApproveResult>(`${this.authUrl}/${id}/Approve`, body);
  }

  public reject(id: number, reason: string): Observable<AccountRequest> {
    return this.http.post<AccountRequest>(`${this.authUrl}/${id}/Reject`, { reason });
  }
}
